<script>
	import Alert from './componentes/Alert.svelte';
	import ModuloPago from './componentes/ModuloPago.svelte';
	import { iduser, sucursal, urlapp, miPermiso } from './stores/store.js';
	import ModalPago from './componentes/ModalPago.svelte';
	import Modal from './components/Modal.svelte';
	import Carrito from './components/CarritoLotes.svelte';
	import Totales from './components/Totales.svelte';

	import Datoslote from './componentes/Datoslote.svelte';

	import AnimationContainer from './components/AnimationContainer.svelte';
    import { moneda, moneda4, object2array, postData } from "./scripts";
    import { push } from "svelte-spa-router";
    //import {breakpoint, platform} from './MediaQuery.svelte'
    import { login, prefix, urlapi, viewsXpages } from './stores/store';
    import moment from 'moment'
    import { breakpoint } from './componentes/MediaQuery.svelte';
    import Input from './componentes/Forms/Input.svelte';

    let carritoObj=false;

    /* PERMISOS */
    let viewPage=false;
    export let params = {}
    let id=params.id;

    let hoy=new Date().toISOString().substring(0, 10);
    let lotes={fechaIngreso:"",fechaLote:"",id:"",nreferencia:"",observaciones:"",proveedor:"",status:"E"};

    let productos=[];
    let total_productos=0
    let total=0

    if($login===false)
    {
        push('/login')
    } else if($miPermiso.facturacion.insert===false) {
        push('/sinpermiso')
    } else {
        postData($urlapi, [{ 'cmd':'globales_getOptions' }])
            .then(data => {
                viewPage=true;
        });
    }

    /* FIN PERMISOS */
    
    


    let load=function(id) {
            console.log(`IDLOTE: ${id}`)

            postData($urlapi, [{'cmd':'lotes_edit','idlote':id,'user':{ 'iduser':$iduser }}])
            .then(data => {
                lotes=data[0]['result'];
                productos=object2array(data[0]['productos']);
                total=0;
                productos.forEach((element) => {
                    total+=Number(element.total);
                    total_productos+=Number(element.unidades);
                });
            });
    }

    load(id)

    let printDetalleLote= function() {
        window.open(`${$urlapp}print/lote.php?idlote=${id}`);
    }


</script>

{#if viewPage===true}
<!-- <Navbar /> -->
<AnimationContainer container={false}>

    <div class="container-fluid bg-dark pt-1 pb-1">
        <div class='row'>
            <div class="col-12">

                <div class="float-end"
                    class:mt-1={$breakpoint !== 'xxl'}
                >
                    <button type="button"
                        class:btn-lg={$breakpoint === 'xxl'}
                        class:btn-sm={$breakpoint !== 'xxl'}
                        on:click={printDetalleLote} class='btn btn-info'><i class="bi bi-printer me-1"></i>IMPRIMIR</button>
                    <button type="button"
                        class:btn-lg={$breakpoint === 'xxl'}
                        class:btn-sm={$breakpoint !== 'xxl'}
                        on:click={()=>push('/lotes')} class='btn btn-warning'><i class="bi bi-box-arrow-left me-1"></i>SALIR</button>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid mt-2">
        <div class='row'>
            
            <div class="col-12">
                <!-- <Datoslote bind:lote={lotes}/> -->
                <div class="card mt-2 mb-2" >
                    <div class="card-header">
                        <div class='row'>
                            <div class="col-2"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>ID:</small><br/><strong>{id}</strong></p></div>
                            <div class="col-2"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>FECHA INGRESO:</small><br/><strong>{moment(lotes.fechaIngreso, "YYYY-MM-DD").format('L')}</strong></p></div>
                            <div class="col-2"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>FECHA COMPRA:</small><br/><strong>{moment(lotes.fechaLote, "YYYY-MM-DD").format('L')}</strong></p></div>
                            <div class="col-6"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>PROVEEDOR:</small><br/><strong>{lotes.proveedor}</strong></p></div>
                            <div class="col-6"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>REFERENCIA:</small><br/><strong>{lotes.nreferencia}</strong></p></div>
                            
                            <div class="col-4"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>ESTATUS:</small><br/><strong class:text-danger={lotes.status=='A'} class:text-success={lotes.status=='E'}>{(lotes.status=='E')?'EMITIDO':'ANULADO'}</strong></p></div>
                            <div class="col-12"><p class='mb-1 lh-1 text-primary'><small class='text-muted'>OBSERVACIONES:</small><br/><strong>{lotes.observaciones}</strong></p></div>
                        </div>
                    </div>
                </div>                 
            </div>
        </div>

        <div>
                <table class='table table-striped'>
                    <thead>
                        <tr class="table-dark">
                            <th style='width:120px;'>CÓDIGO</th>
                            <th style='width:70px;'>CANTIDAD</th>
                            <th>DESCRIPCIÓN</th>
                            <th style='width:100px;' class='text-end'>PRECIO</th>
                            <th style='width:100px;' class='text-end'>TOTAL</th>
                            <th style='width:70px;'>EXISTENCIA</th>                            
                        </tr>
        
                    </thead>

                    <tbody>
                        {#each productos as item,index}
                            <tr>
                                <td>{item.codart}</td>
                                <td class='text-end'>{item.unidades}</td>
                                <td>{item.descripcion}</td>
                                <td class='text-end'>{moneda4(item.precio,'Q.')}</td>
                                <td class='text-end'>{moneda4(item.total,'Q.')}</td>
                                <td class='text-end'>{item.existencia}</td>                                
                            </tr>
                        {:else}
                            <tr>
                                <td colspan='7'><span class='text-danger fw-bold'>SIN PRODUCTOS</span></td>
                            </tr>
                        {/each}
                    </tbody>
                    <tfoot>
                        <tr class="table-dark">
                            <th>CANTIDAD</th>
                            <th class='text-end'>{total_productos}</th>
                            <th>&nbsp;</th>
                            <th class='text-end'>TOTAL</th>
                            <th class='text-end'>{moneda4(total,'Q.')}</th>
                            <th>&nbsp;</th>           
                        </tr>
                    </tfoot>                

                </table>
        </div>
    </div>

</AnimationContainer>    
{/if}


<style>
table.table th,table.table td { 
    font-size:0.8em;
    padding:4px;
} 

</style>